import styled, { injectGlobal } from 'styled-components';
import { rem, em } from 'polished';
import { isDefaultThemeMode } from './themed';
import * as colors from './components/colors';
import { origin } from 'utils/print';
import { media } from 'core/layout';

if (__isBrowser__) { // eslint-disable-line no-undef
  import('wicg-focus-ring')
  .then(focusRingModule => {
    // NOTE: Bez .then nez' kāpēc nenostrādā
  });
}

injectGlobal`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  html {
    &.no-scroll {
       ${media.tablet`
        overflow: hidden;
        height:100%;
        width:100%;
        position:absolute;
        top:0;
        left:0;
      `};
    }
  }
  body {
    font-family: 'Roboto', sans-serif;
    font-display: swap;
    margin: 0;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    -webkit-overflow-scrolling : touch;

    &.no-scroll {
      overflow-y: hidden;
      height:100%;

      & > div /* div#root */ {
        overflow-y: hidden;

        & > div /* div[data-reactroot] */ {
          overflow-y: hidden;

          & > div /* div[data-query-id="js-content-container"] */ {
            overflow-y: hidden;
          }
        }
      }
    }
  }

  /**
   * Polyfill for :focus-ring
   * https://github.com/WICG/focus-ring
   */


  *:focus:not(.focus-ring) {
    outline: none;
  }

  .js-focus-ring :focus:not(.focus-ring) {
    outline-width: 0;
  }

  @media print {
    @page {
      size: A4;
      margin: 40pt;
    }

    * {
      -webkit-print-color-adjust: exact !important; /* Chrome, Safari */
      color-adjust: exact !important; /*Firefox*/
    }

    html {
      font-size: 10pt;
    }

    a:after {
      content: "  (" attr(href) ") ";
      color: #757575; /* NOTE: colors mainīgie nenostrādā */
      display: block;
      font-size: 90%;
      margin: 0.3em 0;
      word-wrap: break-word;
    }

    a[href^="/"]:after {
      content: "  (${origin}" attr(href) ") " !important;
    }

    a[href^="#"]:after,
    a[href^="/#"]:after,
    a:not([href]):after {
      display: none;
    }

    h1, h2, h3, h4, h5, h6 {
      page-break-after: avoid;
    }

    table, figure, li {
      page-break-inside: avoid;
    }
  }
`;

const focusRingStyle = (props) => (
  isDefaultThemeMode(props) ? 'solid' : 'dashed'
);

export const ThemeReset = styled.div`
  background-color: ${colors.background};
  padding-top: ${props => rem(65)}; /* fixed header height */

  display:flex;
  flex-direction: column;
  min-height: 100%;

  & > div {
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
  }

  a {
    text-decoration-skip: ink;
  }

  i {
    font-style: normal;
    display: inline-flex;
    pointer-events: none;
    vertical-align: middle;
  }

  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 500;
  }

  input, textarea, select, button {
    font-family: inherit;
    font-size: ${em(14)};
  }

  .focus-ring {
    outline-color: ${colors.focus};
    outline-style: ${focusRingStyle};
    outline-offset: 2px;
    outline-width: 2px;
  }

  @media print {
    padding-top: 0 !important;
    min-height: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/core/theme/ThemeReset.js